import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  input {
    height: 100%;
  }
`

const invalidColor = '#DB2828'
export const SelectStyle = (invalid: boolean | undefined) => {
  return {
    container: (provided: any) => ({
      ...provided,
      height: '100%',
      width: '100%',
    }),
    control: (provided: any) => ({
      ...provided,
      height: '100%',
      width: '100%',
      boxShadow: invalid ? invalidColor : provided.boxShadow,
      borderColor: invalid ? invalidColor : provided.borderColor,
      '&:hover': {
        borderColor: invalid ? invalidColor : provided.borderColor,
        cursor: 'pointer',
      },
    }),
    indicatorsContainer: () => ({
      display: 'none',
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 3000,
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      left: 12,
    }),
    groupHeading: (provided: any) => ({
      ...provided,
      fontSize: '1rem',
      borderBottom: 'solid 1px #CCCCCC',
    }),
    group: (provided: any) => ({
      ...provided,
    }),
  }
}
